import { Injectable } from '@angular/core';
import {Router} from "@angular/router";
import {Credentials} from "../models/credentials";
import {UserModelResponse} from "../models/userResponse.model";

@Injectable()
export class LocalDataService {
  credentials?:Credentials;
  localTime:Date;
  constructor(private _router:Router) {
  }

  /*
  this method evaluate is credentials exist or if token has valid time
  */
  getCredentials(view="home"){
    console.log("inside of get credentials");
    if(localStorage.getItem('credentials')===null){
      this._router.navigate(['login']);
    }
    else{
      console.log("credentials found");
      this.credentials = JSON.parse(localStorage.getItem('credentials'));
      if(!this.validateTokenDate()){
        console.log("token has more than 10 days is nedded to relogin!")
        this.deleteCredentials();
        this._router.navigate(['login']);
      }
      else{//in this step there is a token valid so redirect to home
         this._router.navigate([view]);
     }
    }
  }

  saveCredentials(userResponse:UserModelResponse){
    this.credentials = new Credentials(new Date().valueOf().toString(),userResponse);
    localStorage.setItem('credentials',JSON.stringify(this.credentials));
    this._router.navigate(['login']);
  }

  getAuth_Token():Date{
    return JSON.parse(localStorage.getItem('credentials')).token_date;
  }

  deleteCredentials(){
    localStorage.removeItem('credentials');
    this.credentials = null;
    //localStorage.clear();
  }

  // validateTokenDate(tokenDate:Date):number{
  //   let actualDate = new Date();
  //   let timeDiff = Math.abs(actualDate.getTime() - tokenDate.getTime());
  //   //console.log("duration of token: "+Math.ceil(timeDiff / (1000 * 3600 * 24)));
  //   return Math.ceil(timeDiff / (1000 * 3600 * 24));
  // }

  validateTokenDate():boolean{
    let expires = this.credentials.userMR.expires_in + "000";
    let time = Number(this.credentials.token_date) + Number(expires);//fecha en que se genero el token mas 10 dias en milisegundos
    if(time>=new Date().valueOf()) return true;
    return false;
  }

  public saveObj(obj:any,name:string){
    console.log("Local Data services: saveObj");
    localStorage.setItem(name,JSON.stringify(obj));
    console.log("se guardo "+name);
  }

  public deleteObj(name:string){
    console.log("Local Data services: deleteObj");
    localStorage.removeItem(name);
    console.log("se elimino "+name);
  }

  public getObj(name:string):any{
    if(localStorage.getItem(name)===null){
      //this._router.navigate(['login']);
    }else{
      return JSON.parse(localStorage.getItem(name));
    }
  }


}



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/services/local-data.service.ts